import { isFilled } from '@prismicio/client';
import { HorizontalContentCard } from '@/components/redesign/HorizontalContentCards';
import {
  ArrowLine,
  StepBody,
  StepTitle,
} from '@/components/redesign/NumberedIconStepCard';
import type { StackedStep } from './types';

/**
 * Grid config for the stacked layout, colocated with the card that needs it:
 * one full-width column, 28px between cards, 25px of breathing room top and
 * bottom (Figma).
 */
export const STACKED_GRID_CLASS = 'grid-cols-1 gap-7 py-[25px]';

/**
 * Figma gives a fixed 114px height and 24px side padding. Height is applied as
 * a minimum so longer copy grows the card instead of clipping.
 */
const CARD_CLASS =
  'min-h-[114px] justify-center gap-1 border-b border-black/5 p-4 px-6';

type Props = {
  step: StackedStep;
};

/**
 * Card for the full-width `redesignCardsStacked` layout: a bold title over a
 * single arrow-led line of copy. No icon tile, no index, no button.
 */
export function StackedStepCard({ step }: Props) {
  return (
    <HorizontalContentCard className={CARD_CLASS}>
      <StepTitle
        field={step.step_title}
        className="text-[20px] font-semibold leading-[1.5] text-[#041118] md:text-[22px]"
      />

      {isFilled.richText(step.step_description) && (
        <ArrowLine
          className="items-start"
          iconClassName="mt-[5px] size-[14px] text-[#4b0fea]"
        >
          <StepBody
            field={step.step_description}
            className="min-w-0 text-[16px] font-light leading-[1.5] text-[#041118] md:text-[18px]"
          />
        </ArrowLine>
      )}
    </HorizontalContentCard>
  );
}
